<template>
 <v-container>
  <v-layout  row wrap>
    <v-flex xs12>
       <v-autocomplete
          v-bind:items="staedte"
          item-text="name"
          item-value="name"
          v-model="stadt"
          required
          solo
          height="60"       
          label="Stadt auswählen"
          prepend-inner-icon="location_searching"
          no-data-text
          class="mr-2 "
          @change="StadtWahl()"
        ></v-autocomplete>        
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>

export default {
  props: ['staedte'],
  data () {
    return {
      stadt: ''
    }
  },
  methods: {
    StadtWahl () {
      // this.$emit('neueStadt')

      this.$store.dispatch('setStadt', this.stadt)
      const context = this
      // Vue Fix.. @change
      setTimeout(() => {
        // console.log(context.stadt)
        this.$router.push({
          name: 'Landing',
          params: {
            landing: context.$route.params.landing,
            stadt: context.stadt.toLowerCase()
          }
        })
      }, 0)
    }

  },
  computed: {
  },
  mounted: function () {

  }
}
</script>

<style>
</style>